<template>
  <div>
    <bread-crumb-cas :routeList="breadArray" labelType="common"></bread-crumb-cas>
    <top-bar
      :isShowSelect="isShowSelect"
      placeholder="请选择所属业务"
      :data="data"
      :clickAddButton="clickAddButton"
    ></top-bar>

    <base-table :tableData="tableData" @handleClick="handleClick"></base-table>
    <pagination
      @sizePageChange="paginationChangeProduct"
      :paginationDatas="paginationDataProduct"
    >
    </pagination>
    <!-- <modal
      :isShow="dialogShow"
      title="被驳回理由"
      :isShowBtn="isShowBtn"
      :btnText="btnText"
      @one="handleDialog(false)"
      @update:isShow="handleDialog(false)"
      @two="handleDialogSubmit"
    >
      <div class="base-dialog">
        <el-form :model="formList"  :rules="rules">
          <el-form-item
            label="分类名称"
            prop="nameValue"
          >
            <el-input
              v-model="formList.nameValue"
              class="base-dialog-input"
              autocomplete="off"
              type="text"
              placeholder="请输入"
              maxlength="10"
              show-word-limit
            ></el-input>

          </el-form-item>
        </el-form>
      </div>
    </modal> -->
    <modal
      :isShow.sync="dialogShowLabel"
      :title="title"
      :isShowBtn="isShowBtn"
      :btnText="btnText"
      @clickHandler="addClickHandler"
      @one="handleDialogLabel(false)"
      @update:isShow="handleDialogLabel(false)"
      @two="handleDialogSubmitLabel"
    >
      <div class="base-dialog">
        <el-form :rules="rules" :model="formList" label-width="80px" ref="classifyName">
          <el-form-item label="分类名称" prop="nameValue">
            <el-input
              v-model="formList.nameValue"
              class="base-dialog-input"
              :class="{ 'base-dialog-input-border': isRed }"
              autocomplete="off"
              type="text"
              placeholder="请输入"
              maxlength="30"
              show-word-limit
            ></el-input>
            <span class="rules" v-show="isRed"
            ><i class="el-icon-warning-outline"></i>分类名称不可重复</span
            >
            <span class="rules" v-show="isEmpty"
            ><i class="el-icon-warning-outline"></i>分类名称不能为空</span
            >
          </el-form-item>
          <!-- <el-form-item label="标签类型" prop="nameType">
            <el-select v-model="value" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item> -->
        </el-form>
      </div>
    </modal>
    <modal
      :isShow.sync="moveDialog"
      title="移动"
      :isShowBtn="isShowBtn"
      :btnText="mergeMoveBtnText"
      @clickHandler="moveClickHandler"
      width="800px"
    >
      <ContentLabelCascader
        :labelType="1"
        :selectedId="tableVal.id"
        :functionIds="{ getArticleLabel: 'health_cmp_biz_pageAuditLabels', operateApi: 'health_cmp_moveContentLabel' }"
        ref="moveSelectedRef"
      />
    </modal>
    <modal
      :isShow.sync="mergeDialog"
      title="合并"
      :isShowBtn="isShowBtn"
      :btnText="mergeMoveBtnText"
      @clickHandler="mergeClickHandler"
    >
      <ContentLabelCascader
        :labelType="1"
        :selectedId="tableVal.id"
        :functionIds="{ getArticleLabel: 'health_cmp_biz_pageAuditLabels', operateApi: 'health_cmp_mergeContentLabel' }"
        ref="moveSelectedRef"
      />
    </modal>
    <modal
      :isShow.sync="deleteDialog"
      title="删除"
      :isShowBtn="isShowBtn"
      :btnText="btnText"
      @clickHandler="deleteClickHandler"
    >
      <div class="dialogVal">确认删除</div>
    </modal>
    <modal
      :isShow.sync="attributeShow"
      title="属性"
      :isShowBtn="isShowBtn"
      :btnText="btnText"
      @clickHandler="btnTextClickHandler"
    >
      <div class="dialogVal">
        <el-checkbox-group v-model="checkedCities" @change="changeCheck">
          <el-checkbox v-for="item in checkList" :key="item.id" :label="item.id">{{ item.name }}</el-checkbox>
        </el-checkbox-group>
      </div>
    </modal>
  </div>
</template>

<script>
import pagination from '../../../../../components/pagination'
import topBar from "../../../../../components/topBar"
import baseTable from "@/components/baseTable"
import ContentLabelCascader from '@/components/select/ContentLabelCascader';
import breadCrumbCas from "../../../../../components/breadCrumbCas"
import modal from "../../../../../components/modal"
import {
  saveOrUpdateLabelGroup,
  pageContentLabelGroups,
  deleteLabelGroupById,
  saveOrUpdateContentLabel,
  pageContentLabelsByGroupId,
  deleteContentLabelById,
  getTagAttributes
} from "../../../../../api/man.js"
import { mapState } from 'vuex';

export default {
  name: "commonLabel",
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入名称'))
      } else {
        callback()
      }
    }
    return {
      attributeShow: false, // 属性弹窗
      checkList: [
        {
          id: 2,
          name: '写手端不可见'
        },
        {
          id: 3,
          name: 'C端用户不可见'
        }],
      checkedCities: [],
      title: '',
      isRed: false,
      paginationDataProduct: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      tableData: {
        tableList: [],
        tableHeader: [
          {
            label: '分类ID',
            prop: 'id'
          },
          {
            label: '分类名称',
            prop: 'name'
          },
          {
            label: '创建时间',
            prop: 'createTime'
          },
          {
            label: '创建人',
            prop: 'createUser'
          },
        ],
        tableType: 4,
      },
      isShowSelect: false,

      // 删除弹框
      deleteDialog: false,
      data: [],
      times: null,
      tableVal: {},
      btnText: ["取消", "确认"],
      // 移动弹框
      moveDialog: false,
      // 合并弹框
      mergeDialog: false,
      mergeMoveBtnText: ["取消", "提交"],
      isShowBtn: [true, true, false],
      nameValue: "",
      dialogShow: false,
      dialogShowLabel: false,
      formList: {
        nameValue: "",
        nameType: "",
      },
      rules: {
        nameValue: [
          {validator: validatePass, trigger: 'blur'}
        ],
      },
      rules: {
        nameValue: [
          {required: true, message: '分类名称不能为空', trigger: 'change'}
        ],
      },
      invisibleStatus: '',
      breadArray: [
        {
          name: '标签管理',
          path: '',
          query: undefined,
        },
        {
          name: '通用标签',
          path: '/commonLabel/group',
          query: this.$router.query,
        }
      ]
    }
  },
  components: {
    baseTable,
    topBar,
    breadCrumbCas,
    modal,
    pagination,
    ContentLabelCascader,
  },
  watch: {
    'formList.nameValue'(newValue, oldValue) {
      //
      if (this.$utils.specialCharacters(newValue)) {
        this.$message({
          message: '禁止输入特殊字符',
          type: 'warning'
        });
        this.formList.nameValue = this.$utils.removalSpace(newValue)
      }
    },
    formList: {
      handler(newValue, oldValue) {
        this.isRed = false
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    changeCheck(val) {
      let numStatus = val.toString();
      let numStr1 = '2,3'
      let numStr2 = '3,2'
      if (numStatus == numStr1 || numStatus == numStr2 ) {
        this.invisibleStatus = 4
      } else {
        this.invisibleStatus = numStatus
      }
    },
    // 属性弹窗
    btnTextClickHandler(val) {
      if (val === 'one') {
        this.attributeShow = false
        this.checkedCities = []
      } else if (val === 'two') {
        if (this.invisibleStatus == '') {
          this.invisibleStatus = '1'
        }
        getTagAttributes({
          tenantId: this.tableVal.tenantId,
          id: this.tableVal.id,
          invisibleStatus: this.invisibleStatus,
          // updateInvisibleStatusType: this.tableVal.yn
        }).then(res => {
          if (res) {
            this.checkedCities = [];
            this.$message({
              message: '操作成功',
              type: "success",
            });
            this.attributeShow = false;
          }
          this.pageContentLabelGroups()
        }).catch(err => {
          this.$message.error('操作失败');
        })
        this.attributeShow = false
      }
    },
    paginationChangeProduct(val) {
      this.paginationDataProduct = val
      this.pageContentLabelGroups()
    },
    handleClick(val) {
      if (val.type === 'edit') {
        this.formList.nameValue = val.val.name
        this.dialogShowLabel = true
        this.title = "编辑"
        this.tableVal = val.val
        this.isRed = false
      } else if (val.type === 'goAdmin') {
        // 跳转一级标签路由
        this.$router.push({
          path: `/commonLabels/1`,
          query: {groupId: val.val.id}
        })
      } else if (val.type === 'delete') {
        this.deleteDialog = true
        this.tableVal = val.val
      } else if (val.type === 'attribute') {
        this.attributeShow = true
        this.tableVal = val.val
        // 属性值回显
        if (val.val.invisibleStatus !== 1) {
          if (val.val.invisibleStatus == 4) {
            this.checkedCities = [2, 3]
          } else {
            this.checkedCities = [val.val.invisibleStatus]
          }
        }
        this.invisibleStatus = val.val.invisibleStatus
      } else if (val.type === 'moveLabel') {
        this.moveDialog = true
        this.tableVal = val.val
      } else if (val.type === 'mergeLabel') {
        this.mergeDialog = true
        this.tableVal = val.val
      }
    },
    // 删除弹框
    deleteClickHandler(val) {
      if (val === 'one') {
        this.deleteDialog = false
      } else if (val === 'two') {
        this.deleteLabelGroupById(this.tableVal)
        // this.deleteDialog=false
      }
    },
    // 删除
    deleteLabelGroupById(val) {
      deleteLabelGroupById({
        tenantId: this.$commonJs.getTenantId(),
        labelGroupId: val.id
      })
        .then(res => {
          if (res) {
            this.$message({
              message: '删除成功',
              type: 'success'
            })
          }
          this.deleteDialog = false
          this.paginationDataProduct.currentPage = 1;
          this.pageContentLabelGroups()
        })
        .catch(res => {
          // if(res.data===-1) {
          this.$message.error(
            res.msg
          )
          // }
        })
    },
    // 新增弹框
    addClickHandler(val) {
      let vm = this
      if (val === 'one') {
        this.dialogShowLabel = false
      } else if (val === 'two') {
        if (this.formList.nameValue && this.formList.nameValue.trim() != '') {
          this.saveOrUpdateLabelGroup(this.formList.nameValue)
        } else {
          this.$message.error('请输入分类名称')
        }

        // this.dialogShowLabel = false
      }
    },
    // 合并弹框
    mergeClickHandler(val) {
      if (val === 'one') {
        this.mergeDialog = false
      } else if (val === 'two') {
        this.$refs.moveSelectedRef.handleClick();
        // this.deleteDialog=false
      }
    },
    // 移动弹框
    moveClickHandler(val) {
      if (val === 'one') {
        this.moveDialog = false
      } else if (val === 'two') {
        // this.deleteLabelGroupById(this.tableVal)
        console.log(this.$refs, 9999);
        this.$refs.moveSelectedRef.handleClick();
        // this.deleteDialog=false
      }
    },
    // 分页
    pageContentLabelGroups() {
      let vm = this
      pageContentLabelGroups({
        tenantId: this.$commonJs.getTenantId(),
        labelType: 1,
        contentBusinessId: '',
        // page:2,
        // pageSize:10
        pageNo: this.paginationDataProduct.currentPage,
        pageSize: this.paginationDataProduct.pageSize,
      })
        .then(res => {
          console.log("🚀 ~ pageContentLabelGroups ~ res:", res)
          this.tableData.tableList.splice(0, this.tableData.tableList.length)
          res.data.map(item => {
            this.tableData.tableList.push(item)
          })
          vm.paginationDataProduct.total = res.totalCount
          vm.paginationDataProduct.currentPage = res.pageNo
          vm.paginationDataProduct.pageSize = res.pageSize
        })
    },
    clickAddButton() {
      this.title = '新增'
      this.tableVal = {}
      this.formList.nameValue = ''
      this.dialogShowLabel = true
      this.isRed = false
    },
    handleDialog(val) {
      this.dialogShow = val
    },
    handleDialogLabel(val) {
      // dialogShowLabel
      this.dialogShowLabel = val
    },
    handleDialogSubmit() {
      this.handleDialog(false)
    },
    handleDialogSubmitLabel() {
      this.handleDialogLabel(false)
    },
    // 新增
    saveOrUpdateLabelGroup(name) {
      saveOrUpdateLabelGroup({
        id: this.tableVal.id == undefined ? '' : this.tableVal.id,
        labelType: 1,
        name: name,
        tenantId: this.$commonJs.getTenantId(),
      }).then(res => {
        this.isRed = false
        this.dialogShowLabel = false
        this.pageContentLabelGroups()
      }).catch(error => {
        // this.isRed=true

        this.$message.error(error.msg)


      })
    }
  },
  created() {
    this.pageContentLabelGroups()
  }
};
</script>

<style lang="scss" scoped>

.dialogVal {
  color: #5f5f6b;
  font-size: 16px;
  padding: 30px 0px;
  padding-bottom: 0px;
  text-align: center;
}

.common-audit-tabel {
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  background: white;
  margin-top: 14px;
}

.input-container {
  display: flex;
  justify-content: center;
  padding-top: 20px;

  .input-suffix {
    .el-input {
      width: 276px;
    }
  }
}

.base-dialog {
  width: 400px;
  padding: 30px 26px 0;
  position: relative;
  font-size: 14px;
  color: #2c3443;

  &-input {
    width: 276px;
  }

  &-textarea {
    width: 276px;
    padding-top: 10px;
  }

  .el-form-item__label {
    width: 68px;
    font-weight: bolder;
  }

  .el-input__inner {
    height: 32px;
  }

  // .el-form-item__error {
  //   left: 68px;
  // }
  &__body {
    padding: 30px 26px;
  }

  &__header {
    background-color: #f7f8fb;
    height: 46px;
    display: flex;
    align-items: center;

    .el-dialog__title {
      font-size: 16px;
      color: #333840;
      font-weight: bolder;
    }
  }
}

.base-dialog-input-border {
  position: relative;

  & > input {
    border: 1px solid #F56C6C;
  }
}

.rules {
  position: absolute;
  font-size: .5em;
  color: #F56C6C;
  bottom: -28px;
  left: 0px;
}
</style>
